// CampaignRenderer.tsx
import React from "react";
import FbReachCampaign from "./campaigns/FbReachCampaign";
import GgSiteConversionsCampaign from "./campaigns/GgSiteConversionsCampaign";
// import SalesCampaign from "./SalesCampaign";
// import FollowersCampaign from "./FollowersCampaign";
// import WebsiteTrafficCampaign from "./WebsiteTrafficCampaign";
// import EngagementCampaign from "./EngagementCampaign";
var CampaignRenderer = function (_a) {
    var campaign = _a.campaign, insights = _a.insights;
    // Cabeçalho comum para todas as campanhas
    var Header = function () { return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "font-semibold text-lg ml-4 mt-2" },
            "Campanha: ",
            campaign.name || "??"),
        React.createElement("div", { className: "text-xs text-gray-400 ml-4 mt-2" },
            "Objetivo: ",
            campaign.objective || "Não definido"),
        React.createElement("div", { className: "text-xs text-gray-400 ml-4 mt-2 mb-2" },
            "Descri\u00E7\u00E3o: ",
            campaign.description || "Sem descrição"))); };
    // Verifica se não há dados relevantes para o período
    var current = insights === null || insights === void 0 ? void 0 : insights.current;
    var noData = current &&
        (current.spend === 0 || current.spend === null) &&
        (current.impressions === 0 || current.impressions === null) &&
        (current.clicks === 0 || current.clicks === null) &&
        (current.reach === 0 || current.reach === null);
    if (noData) {
        return (React.createElement("div", null,
            React.createElement(Header, null),
            React.createElement("div", { className: "p-8 text-center text-gray-400 text-lg" },
                "Nenhum dado para este per\u00EDodo.",
                React.createElement("br", null),
                "A campanha n\u00E3o rodou ou n\u00E3o houve resultados.")));
    }
    //campanhas do Facebook
    if (campaign.platform === "facebook") {
        switch (campaign.objective) {
            case "alcance":
                return (React.createElement("div", null,
                    React.createElement(Header, null),
                    React.createElement(FbReachCampaign, { campaign: campaign, insights: insights })));
            // case "vendas":
            //   return (
            //     <div>
            //       <Header />
            //       <SalesCampaign campaign={campaign} insights={insights} />
            //     </div>
            //   );
            // case "seguidores":
            //   return (
            //     <div>
            //       <Header />
            //       <FollowersCampaign campaign={campaign} insights={insights} />
            //     </div>
            //   );
            // case "site":
            //   return (
            //     <div>
            //       <Header />
            //       <WebsiteTrafficCampaign campaign={campaign} insights={insights} />
            //     </div>
            //   );
            // case "engajamento":
            //   return (
            //     <div>
            //       <Header />
            //       <EngagementCampaign campaign={campaign} insights={insights} />
            //     </div>
            //   );
            default:
                return (React.createElement("div", null,
                    React.createElement(Header, null),
                    React.createElement("div", { className: "text-xs text-gray-400 mb-2" },
                        "Insights:",
                        React.createElement("pre", { className: "text-white text-xs bg-gray-800 rounded p-2 mt-1 overflow-x-auto" }, JSON.stringify(insights || {}, null, 2)))));
        }
    }
    //campanhas do Google
    if (campaign.platform === "google") {
        switch (campaign.objective) {
            case "alcance":
                return (React.createElement("div", null,
                    React.createElement(Header, null),
                    React.createElement(GgSiteConversionsCampaign, { campaign: campaign, insights: insights })));
            // case "vendas":
            //   return (
            //     <div>
            //       <Header />
            //       <SalesCampaign campaign={campaign} insights={insights} />
            //     </div>
            //   );
            // case "seguidores":
            //   return (
            //     <div>
            //       <Header />
            //       <FollowersCampaign campaign={campaign} insights={insights} />
            //     </div>
            //   );
            case "site":
                return (React.createElement("div", null,
                    React.createElement(Header, null),
                    React.createElement(GgSiteConversionsCampaign, { campaign: campaign, insights: insights })));
            // case "engajamento":
            //   return (
            //     <div>
            //       <Header />
            //       <EngagementCampaign campaign={campaign} insights={insights} />
            //     </div>
            //   );
            default:
                return (React.createElement("div", null,
                    React.createElement(Header, null),
                    React.createElement("div", { className: "text-xs text-gray-400 mb-2" },
                        "Insights:",
                        React.createElement("pre", { className: "text-white text-xs bg-gray-800 rounded p-2 mt-1 overflow-x-auto" }, JSON.stringify(insights || {}, null, 2)))));
        }
    }
};
export default CampaignRenderer;
